import { Injectable } from '@angular/core';
import { HttpService } from './http.service';

@Injectable()
export class LookupService {
  private lookupURL = '';

  constructor(private http: HttpService) {
  }

  getLookup(lookupApi: string, campusCode: string) {
    this.lookupURL = `${lookupApi}/campusCode/${campusCode}`;
    return this.http.get(this.lookupURL, );
  }

  getLookupBasedOnSearch(lookupApi: string, searchName: string, campusCode: string) {
    let results = [];
    return this.http.get(`${lookupApi}/campusCode/${campusCode}`).then(res => {
      results = res ? res['options'] || [] : [];
      return results[searchName];
    });
  }

  getLookupURL() {
    return this.lookupURL;
  }
}



// WEBPACK FOOTER //
// /home/runner/work/slipresistant/slipresistant/client/src/app/shared/service/lookup.service.ts